<template>
    <transition name="slide-fade" >

        <div  id="academicsHolder " >
            <div class="uk-child-width-1-1" uk-grid>


                <div class="  uk-margin-remove-top uk-padding-large " >

                    <div class="uk-container uk-container-large" v-if="gridView === true">
                        <h2 class="uk-heading-bullet uk-text-bold">Natural and Applied Science, Allied Health and Nursing Programmes</h2><br>
                        <div class="uk-child-width-1-1 uk-child-width-1-3@m uk-child-width-1-4@l " uk-grid>
                            <div v-for="item in filterDegree" >
                                <div class="uk-card uk-card-default" style="border-radius: 15px;">
                                    <div class="uk-card-media-top">
                                        <img :src="'http://cmsapi.ncu.edu.jm/' + item.thumbnailImage" class="uk-responsive-height uk-responsive-width" alt=""
                                             style="max-width: 300px; max-height: 300px; height: auto; width: auto; border-top-left-radius: 15px; border-top-right-radius: 15px; ">
                                    </div>
                                    <div class="uk-card-body uk-padding-small" >
                                        <!-- <h4 class="specHeading" style="color: rgb(197,179,88) !important;">{{ item.degreeName }}</h4>-->
                                        <div>
                                            <dl class="uk-description-list" >
                                                <dt class=" uk-text-capitalize uk-text-bold" style="color: rgb(197,179,88) !important; font-size: large; font-weight: bold">{{ item.degreeName }}</dt>
                                                <dd>
                                                    <div>
                                                        <span class=" uk-text-muted ">Program Offerings:</span> <span v-for="(axio, index) in item.levelsOffered" class="uk-text-small uk-text-bold">
                                                          <span v-if="index === 1" class="uk-text-small">, </span> {{ axio.typeAbbr }}
                                                        </span>
                                                    </div>
                                                    <div><span class=" uk-text-success ">College:</span> <span style="font-size: 12px;">{{ item.college }}</span></div>
                                                    <p><span class=" uk-text-primary ">Department:</span> <span style="font-size: 12px;">{{ item.Department }}</span></p>

                                                    <p>
                                                        <button :id="item.id" @click="findNewDegree" class="uk-button uk-button-secondary uk-button-small uk-text-capitalize uk-align-right">Learn More</button>
                                                    </p>
                                                </dd>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="uk-container uk-container-small" v-if="tableView === true">

                        <div class="uk-overflow-auto"  v-if="tableView === true">
                            <table class="uk-table  uk-table-divider ">
                                <thead>
                                <tr>
                                    <th > <h3 style="color: rgb(197,179,88) !important;" class="uk-heading-bullet specHeading">List of Undergraduate Degrees</h3></th>
                                    <th class="uk-table-shrink">Dept.</th>
                                    <th class="uk-table-shrink">A.Sc</th>
                                    <th class="uk-table-shrink">A.A</th>
                                    <th class="uk-table-shrink">B.Sc</th>
                                    <th class="uk-table-shrink">B.A</th>
                                </tr>
                                </thead>
                                <tbody class="">
                                <tr v-for="item in filterDegree">
                                    <td>
                                        <a href="javascript:" :id="item.id" v-on:click="findNewDegree" :uk-tooltip="'Learn more about a degree in ' + item.degreeName" class="uk-button-link  uk-uk-text-bold ">{{ item.degreeName }} </a>
                                    </td>

                                    <td>

                                        <span  class="uk-margin-small-right uk-text-primary uk-text-small" ><i>{{ item.department }}</i></span>
                                    </td><td>

                                    <span v-if="item.associate_science" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                                </td>
                                    <td class="uk-text-center">
                                        <span v-if="item.associate_arts" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                                    </td>
                                    <td>

                                        <span v-if="item.bachelor_science" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                                    </td>
                                    <td class="uk-text-center">
                                        <span v-if="item.bachelor_arts" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                                    </td>

                                </tr>


                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </transition>
</template>

<script>
    export default {
        name: "cnasDegrees",
        data(){
            return {
                image: location.origin + '/static/logo.png',
                imgHide: true,
                tableView: false,
                gridView: true,
                searchDegree: ''
            }
        },
        methods: {
            findDegree: function(event){
                //this.$store.commit('getArticle', (event.target.id))
                //console.log(event.target)
                this.$router.push({ path: '/undergrad', query: { degreeName: event.target.id, degreeType: 'u_programs' }})
            },
            findNewDegree: function(event){
                //this.$store.commit('getArticle', (event.target.id))
                //console.log(event.target)
                this.$router.push({ path: '/undergrad', query: { degree: event.target.id }})
            },
            switchToGrid: function(){
                this.tableView = false
                this.gridView = true
            },
            switchToTable: function(){
                this.tableView = true
                this.gridView = false
            },
        },
        computed: {
            loadDegrees: function () {
                //this.pageLoad = true
                //console.log(this.$store.state.undergradDegrees.associate_degree)
                return this.$store.state.degree.undergradDegrees
            },
            loadNewDegrees: function () {
                //this.pageLoad = true
                //console.log(this.$store.state.undergradDegrees.associate_degree)
                return this.$store.state.undergradTedDegrees
            },
            filterDegree: function(){
                const searchTerm = new RegExp(this.searchDegree, 'i');
                //const searchEvent = new RegExp(this.search_by_event_type, 'i');

                /* this.model.filter((item) =>
                   searchTerm.test(item.clients_association) &&
                   searchEvent.test(item.event_type)
                 );*/
                return this.loadNewDegrees.filter((degree) =>{
                    return degree.degreeName.match(searchTerm)
                })
            }
        },
        mounted(){
            this.$store.dispatch('getUndergraduateDegreesByCollege', {
                department: "Natural And Applied Sciences, Allied Health and Nursing"
            })
            window.scrollTo(0, 0);
        },
        beforeCreate(){
            this.$store.dispatch('degree/AllUndergradDegrees')

        },
        updated(){
            this.imgHide = false
        },
        metaInfo: {
            // Children can override the title.
            title: 'NCU Undergraduate Degrees',
            // Result: My Page Title ← My Site
            // If a child changes the title to "My Other Page Title",
            // it will become: My Other Page Title ← My Site
            //titleTemplate: '%s ← My Site',
            // Define meta tags here.
            meta: [
                {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
                {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                {name: 'description', content: 'Undergraduate Degrees offered by Northern Caribbean University '}
            ]
        }
    }
</script>

<style scoped>

    .colorIt{
        color: #333 !important;
    }
    .borderIt{
        border: #333 solid 1px !important;
    }
    .bgIt{
        background-color: #333 !important;
    }
    .whiteIt{
        color: white !important;
    }
    .smallSize{
        font-size: 10pt !important;
        padding-left: 15px;
    }
    h4, h5{
        color: silver !important;
    }
    tr > td{
        border: 1px solid #EEEEEE;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 15px;
        padding-right: 15px;
    }
</style>
